import moment from 'moment'
import { formatDateSpecific } from '@/helpers/helpers'
import { xcalacocoBookingStatusVariants, xcalacocoBookingReasonOptions } from '@/data/xcalacocoBookings'

export const formatXcalacocoDay = date => (date ? formatDateSpecific({ date, toFormat: 'DD/MM/YYYY' }) : '—')

export const formatXcalacocoDateTime = date => (date ? formatDateSpecific({ date, toFormat: 'DD/MM/YYYY HH:mm' }) : '—')

export function xcalacocoNightsLabel(booking) {
  if (!booking || !booking.dateIn || !booking.dateOut) return ''
  const nights = moment(booking.dateOut).diff(moment(booking.dateIn), 'days')
  return `${nights} ${nights === 1 ? 'noche' : 'noches'}`
}

export function xcalacocoReasonLabel(reason) {
  const option = xcalacocoBookingReasonOptions.find(item => item.value === String(reason))
  return option ? option.text : '—'
}

export const xcalacocoStatusVariant = status => xcalacocoBookingStatusVariants[status] || 'secondary'

export function xcalacocoGuestNames(booking) {
  const guests = booking && Array.isArray(booking.guests) ? booking.guests : []
  return guests.map(guest => `${guest.name} ${guest.lastname}`.trim()).join(', ')
}

// Legacy records may hold several guests; the first one is the holder
export function xcalacocoHolderName(booking) {
  const holder = booking && Array.isArray(booking.guests) ? booking.guests[0] : null
  return holder ? `${holder.name} ${holder.lastname}`.trim() : ''
}
